import { endOfDay, endOfToday } from 'date-fns';
import template from './dateRange.modal.component.html';

/* @ngInject */
function dateRangeController(
) {
  const vm = this;
  vm.selectDate = selectDate;
  vm.clear = clear;
  vm.confirm = confirm;
  vm.cancel = cancel;

  vm.dpOptions = {
    showWeeks: false,
    maxDate: endOfToday()
  };

  vm.$onInit = () => {
    const { endRangeDate } = vm.resolve;
    if (endRangeDate) {
      selectDate(endRangeDate);
    } else {
      clear();
    }
  };

  function selectDate(date) {
    dateSetManually(date);
    vm.rangeMode = true;
  }

  function dateSetManually(date) {
    vm.selectedDate = endOfDay(date);
    vm.startOfRange = new Date(vm.selectedDate);
    vm.startOfRange.setDate(vm.selectedDate.getDate() - vm.resolve.daysOfDataToPull);
  }

  function clear() {
    dateSetManually(new Date());
    vm.rangeMode = false;
  }

  function confirm() {
    // value is a valid date or undefined
    vm.close({ $value: vm.rangeMode ? vm.selectedDate : undefined });
  }

  function cancel() {
    vm.dismiss();
  }
}


export default {
  name: 'dateRangeModal',
  controller: dateRangeController,
  controllerAs: '$modal',
  template,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};
